import React, { useState } from 'react';
import { FiPlay } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const videos = [
  'SIZ_JOa5h6M',
  '5h3xKKNPHXI',
  '0lF_9WhXpHg'
];

const VideoCard = ({ id }) => {
  const [showVideo, setShowVideo] = useState(false);

  if (showVideo) {
    const videoSrc = `https://www.youtube.com/embed/${id}?autoplay=1&modestbranding=1&rel=0&enablejsapi=1`;
    return (
      <div className="aspect-video rounded-xl overflow-hidden shadow-sm bg-black relative">
        <iframe
          width="100%"
          height="100%"
          src={videoSrc}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    );
  }

  return (
    <div 
      className="aspect-video rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all bg-gray-100 relative group cursor-pointer"
      onClick={() => setShowVideo(true)}
    >
      <img 
        src={`https://img.youtube.com/vi/${id}/mqdefault.jpg`} 
        alt="Video thumbnail" 
        className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
          <SafeIcon icon={FiPlay} className="w-6 h-6 text-[#F28423] ml-1" />
        </div>
      </div>
    </div>
  );
};

const HighlightedVideos = () => {
  return (
    <div className="py-4">
      <h2 className="text-2xl font-bold mb-6 text-gray-900">Utvalda videoklipp</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {videos.map((id) => (
          <VideoCard key={id} id={id} />
        ))}
      </div>
    </div>
  );
};

export default HighlightedVideos;